<div class="innoLive-teaser-header" *ngIf="configuration">
  <app-back-button [title]="'module.innoLive.moduleName' | translate" (backClicked)="gotoDashboard()"> </app-back-button>
</div>

<div class="innoLive-teaser" *ngIf="configuration">
  <div class="innoLive-teaser-top">
    <app-carousel [imageCount]="getImageCount()" [assets]="getAssets()" [baseURL]="baseURL" class="innoLive-teaser-carousel"> </app-carousel>
  </div>
  <div class="innoLive-teaser-bottom"></div>
  <div class="advantages">
    <div class="description-container">
      <h1>Was ist LEW Inno.Live?</h1>
      <div>
        <h5 class="desc">
          Die Stadt oder Kommune der Zukunft ist sauber, intelligent und vernetzt. Um diesem Ziel näher zu kommen, haben wir LEW Inno.Live ins Leben gerufen.
          Wir bieten Ihnen mit unserem Tool das technische Fachwissen, die notwendige Infrastruktur und die dazugehörige Software-Plattform, um auch Ihre Stadt
          oder Kommune zu einer "Smart City" zu machen.
        </h5>
      </div>
      <div class="button-container">
        <div class="button-container-main">
          <button class="btn btn-outline-primary" (click)="redirectToMoreInfo()">Mehr Infos</button>
          <button class="btn btn-white" (click)="redirectToDemo()">Demo</button>
        </div>
      </div>
    </div>
  </div>
</div>
